import React from 'react';
import AdvertisementPaymentCompleteWrapper from 'components/AdvertisementPaymentCompleteWrapper';

export default function AdvertisementPaymentCompleteContainer() {
  return <AdvertisementPaymentCompleteWrapper />;
}
